import { white, dustygray } from '../colors';
export var MuiOutlinedInput = {
    styleOverrides: {
        root: {
            backgroundColor: white,
            '& [class*=MuiInputBase-inputMultiline]': {
                height: 'auto',
            },
            '& [class*=MuiIconButton-edgeEnd]': {
                height: 28,
            },
        },
        notchedOutline: {
            borderColor: dustygray,
        },
    },
};
